<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.movimentacaoTipos"
                            :validations="validations.movimentacaoTipo"
                            @change="handleMovimentacaoTipoChange"
                            label="Tipo de movimentação"
                            show-default-option
                            v-model="model.movimentacaoTipo"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.movimentacaoSubtipos"
                            @change="handleMovimentacaoSubtipoChange"
                            default-option-text="Todos"
                            label="Subtipo de movimentação"
                            show-default-option
                            text-field="nome"
                            v-model="model.movimentacaoSubtipoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.setores"
                            @change="handleSetorChange"
                            default-option-text="Todos"
                            label="Setor"
                            show-default-option
                            text-field="nome"
                            v-model="model.setorId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Usuário"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.origensProgramaticas"
                            default-option-text="Todas"
                            label="Origem programática"
                            show-default-option
                            text-field="nome"
                            v-model="model.origemProgramaticaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :disabled="!model.movimentacaoTipo"
                            :repository="repositories.relatorioMovimentacaoGeral.material"
                            :request-query-string-params="autocompleteQueryStringParams"
                            :search-fields="autocompleteFields"
                            label="Material"
                            text-field="descricao"
                            uppercase
                            v-model="model.material"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="items && items.length > 0">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-dropdown
                        class="mr-2"
                        color="primary"
                        cols="1"
                        menu-class="auto-scroll"
                        no-caret
                        small
                        title="Colunas"
                        v-rkm-tooltip.hover
                    >
                        <template v-slot:button-content>
                            <rkm-icon icon="columns" />
                        </template>

                        <rkm-form-checkbox
                            :indeterminate="indeterminate"
                            @change="selectAll"
                            class="mx-2"
                            v-model="selectedAll"
                        >
                            Todas
                        </rkm-form-checkbox>

                        <rkm-form-checkbox-group
                            :options="optionalColumns"
                            class="mx-2"
                            stacked
                            text-field="label"
                            v-model="selectedCols"
                            value-field="key"
                        />
                    </rkm-dropdown>

                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="items"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    @sort-changed="onSortChanged"
                />
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        autocompleteQueryStringParams() {
            return {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                movimentacao_tipo: this.model.movimentacaoTipo,
                movimentacao_subtipo_id: this.model.movimentacaoSubtipoId,
                unidade_id: this.model.unidadeId,
                infraestrutura_id: this.model.infraestruturaId,
                setor_id: this.model.setorId,
                usuario_id: this.model.usuarioId,
                origem_programatica_id: this.model.origemProgramaticaId,
            }
        },
        autocompleteFields() {
            return [
                {key: 'codigo_material', searchable: true},
                {key: 'descricao', searchable: true},
            ]
        },
        validations() {
            return {
                periodo: {required: true},
                movimentacaoTipo: {required: true},
            }
        },
        columns() {
            let columns = []

            if (this.model.movimentacaoTipo === 'entrada') {
                columns = [
                    {fixed: true, key: 'dataMovimentacao', label: 'Data da movimentação', sortable: true},
                    {fixed: true, key: 'movimentacaoSubtipoNome', label: 'Subtipo da movimentação', sortable: true},
                    {fixed: true, key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                    {fixed: true, key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                    {key: 'unidadeOrigemNomeFantasia', label: 'Unidade de origem', sortable: true},
                    {key: 'infraestruturaOrigemNome', label: 'Local de atendimento de origem', sortable: true},
                    {key: 'setorNome', label: 'Setor', sortable: true},
                    {key: 'fornecedorNomeFantasia', label: 'Fornecedor', sortable: true},
                    {key: 'origemProgramaticaNome', label: 'Origem programática', sortable: true},
                    {key: 'documentoNumero', label: 'Número do documento', sortable: true},
                    {fixed: true, key: 'usuarioNome', label: 'Usuário', sortable: true},
                    {key: 'usuarioSolicitanteNome', label: 'Usuário solicitante', sortable: true},
                    {key: 'materialCodigo', label: 'Código do material', sortable: true},
                    {fixed: true, key: 'materialDescricao', label: 'Material', sortable: true},
                    {key: 'grupoNome', label: 'Grupo', sortable: true},
                    {fixed: true, key: 'quantidade', label: 'Quantidade', sortable: true},
                    {fixed: true, key: 'valorUnitario', label: 'Valor unitário', sortable: true},
                    {key: 'valorTotal', label: 'Valor total', sortable: true},
                    {key: 'lote', label: 'Lote', sortable: true},
                    {key: 'validadeLote', label: 'Validade do lote', sortable: true},
                ]
            } else {
                columns = [
                    {fixed: true, key: 'dataMovimentacao', label: 'Data da movimentação', sortable: true},
                    {fixed: true, key: 'movimentacaoSubtipoNome', label: 'Subtipo da movimentação', sortable: true},
                    {fixed: true, key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                    {fixed: true, key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                    {key: 'unidadeDestinoNomeFantasia', label: 'Unidade de destino', sortable: true},
                    {key: 'infraestruturaDestinoNome', label: 'Local de atendimento de destino', sortable: true},
                    {key: 'setorNome', label: 'Setor', sortable: true},
                    {key: 'fornecedorNomeFantasia', label: 'Fornecedor', sortable: true},
                    {key: 'origemProgramaticaNome', label: 'Origem programática', sortable: true},
                    {key: 'documentoNumero', label: 'Número do documento', sortable: true},
                    {fixed: true, key: 'usuarioNome', label: 'Usuário', sortable: true},
                    {key: 'usuarioDestinoNome', label: 'Usuário de destino', sortable: true},
                    {key: 'materialCodigo', label: 'Código do material', sortable: true},
                    {fixed: true, key: 'materialDescricao', label: 'Material', sortable: true},
                    {key: 'grupoNome', label: 'Grupo', sortable: true},
                    {fixed: true, key: 'quantidade', label: 'Quantidade', sortable: true},
                    {fixed: true, key: 'valorUnitario', label: 'Valor unitário', sortable: true},
                    {key: 'valorTotal', label: 'Valor total', sortable: true},
                    {key: 'lote', label: 'Lote', sortable: true},
                    {key: 'validadeLote', label: 'Validade do lote', sortable: true},
                ]
            }

            return columns
        },
        optionalColumns() {
            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {
            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.almoxarifado'),
            impressao: this.getConectaSusRepository('impressao.almoxarifado'),
            relatorioMovimentacaoGeral: this.getConectaSusRepository('almoxarifado.relatorioMovimentacaoGeral'),
        }
    },
    data() {
        return {
            additionals: null,
            form: null,
            indeterminate: true,
            items: null,
            model: null,
            others: {moment},
            selectedAll: false,
            selectedCols: [
                'valorTotal',
            ],
            sortBy: 'dataMovimentacao',
            sortDesc: false,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioMovimentacaoGeral.create()
                .then((response) => {
                    this.additionals = response.data.additionals
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                movimentacaoTipo: this.model.movimentacaoTipo,
                movimentacaoSubtipoId: this.model.movimentacaoSubtipoId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                setorId: this.model.setorId,
                usuarioId: this.model.usuarioId,
                origemProgramaticaId: this.model.origemProgramaticaId,
                materialId: this.model.material ? this.model.material.id : null,
            }

            this.setLoading()

            this.repositories.relatorioMovimentacaoGeral.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.items = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.movimentacaoTipos = []
            this.form.movimentacaoSubtipos = []
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.setores = []
            this.form.usuarios = []
            this.form.origensProgramaticas = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.movimentacaoTipo = null
            this.model.movimentacaoSubtipoId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.setorId = null
            this.model.usuarioId = null
            this.model.origemProgramaticaId = null
            this.model.material = null
            this.items = []

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                movimentacaoTipo: this.model.movimentacaoTipo,
                movimentacaoSubtipoId: this.model.movimentacaoSubtipoId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                setorId: this.model.setorId,
                usuarioId: this.model.usuarioId,
                origemProgramaticaId: this.model.origemProgramaticaId,
                materialId: this.model.material ? this.model.material.id : null,
                sortBy: this.camelToSnake(this.sortBy),
                sortDesc: this.sortDesc,
                selectedCols: this.fields.map(f => ({
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                })),
            }

            this.repositories.impressao.relatorioMovimentacaoGeral(this.camelObjectKeysToSnakeRecursive(request))
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                movimentacaoTipo: this.model.movimentacaoTipo,
                movimentacaoSubtipoId: this.model.movimentacaoSubtipoId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                setorId: this.model.setorId,
                usuarioId: this.model.usuarioId,
                origemProgramaticaId: this.model.origemProgramaticaId,
                materialId: this.model.material ? this.model.material.id : null,
                sortBy: this.camelToSnake(this.sortBy),
                sortDesc: this.sortDesc,
                selectedCols: this.fields.map(f => ({
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                })),
            }

            this.repositories.exportacao.relatorioMovimentacaoGeral(this.camelObjectKeysToSnakeRecursive(request))
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleMovimentacaoTipoChange(value) {
            this.form.movimentacaoSubtipos = []
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.setores = []
            this.form.usuarios = []
            this.form.origensProgramaticas = []
            this.model.movimentacaoSubtipoId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.setorId = null
            this.model.usuarioId = null
            this.model.origemProgramaticaId = null
            this.model.material = null
            this.items = []

            if (value === null) {
                return
            }

            const request = {
                listar: 'movimentacao-subtipos',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                movimentacaoTipo: value,
            }

            this.setLoading()

            this.repositories.relatorioMovimentacaoGeral.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.movimentacaoSubtipos = Object.assign(response.data.movimentacaoSubtipos)
                    this.form.unidades = Object.assign(response.data.unidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.origensProgramaticas = Object.assign(response.data.origensProgramaticas)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleMovimentacaoSubtipoChange(value) {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.setores = []
            this.form.usuarios = []
            this.form.origensProgramaticas = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.setorId = null
            this.model.usuarioId = null
            this.model.origemProgramaticaId = null
            this.model.material = null
            this.items = []

            if (value === null) {
                return
            }

            const request = {
                listar: 'unidades',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                movimentacaoTipo: this.model.movimentacaoTipo,
                movimentacaoSubtipoId: value,
            }

            this.setLoading()

            this.repositories.relatorioMovimentacaoGeral.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.unidades = Object.assign(response.data.unidades)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.origensProgramaticas = Object.assign(response.data.origensProgramaticas)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.setores = []
            this.form.usuarios = []
            this.form.origensProgramaticas = []
            this.model.infraestruturaId = null
            this.model.setorId = null
            this.model.usuarioId = null
            this.model.origemProgramaticaId = null
            this.model.material = null
            this.items = []

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                movimentacaoTipo: this.model.movimentacaoTipo,
                movimentacaoSubtipoId: this.model.movimentacaoSubtipoId,
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioMovimentacaoGeral.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.origensProgramaticas = Object.assign(response.data.origensProgramaticas)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.setores = []
            this.form.usuarios = []
            this.form.origensProgramaticas = []
            this.model.setorId = null
            this.model.usuarioId = null
            this.model.origemProgramaticaId = null
            this.model.material = null
            this.items = []

            const request = {
                listar: 'setores',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                movimentacaoTipo: this.model.movimentacaoTipo,
                movimentacaoSubtipoId: this.model.movimentacaoSubtipoId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioMovimentacaoGeral.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.setores = Object.assign(response.data.setores)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.origensProgramaticas = Object.assign(response.data.origensProgramaticas)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleSetorChange(value) {
            this.form.usuarios = []
            this.form.origensProgramaticas = []
            this.model.usuarioId = null
            this.model.origemProgramaticaId = null
            this.model.material = null
            this.items = []

            const request = {
                listar: 'usuarios',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                movimentacaoTipo: this.model.movimentacaoTipo,
                movimentacaoSubtipoId: this.model.movimentacaoSubtipoId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                setorId: value,
            }

            this.setLoading()

            this.repositories.relatorioMovimentacaoGeral.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.origensProgramaticas = Object.assign(response.data.origensProgramaticas)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.form.origensProgramaticas = []
            this.model.origemProgramaticaId = null
            this.model.material = null
            this.items = []

            const request = {
                listar: 'origens-programaticas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                movimentacaoTipo: this.model.movimentacaoTipo,
                movimentacaoSubtipoId: this.model.movimentacaoSubtipoId,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                setorId: this.model.setorId,
                usuarioId: value,
            }

            this.setLoading()

            this.repositories.relatorioMovimentacaoGeral.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.origensProgramaticas = Object.assign(response.data.origensProgramaticas))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        selectAll(selected) {
            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
    },
    mounted() {
        this.load()
    },
    mixins: [error, file, repository, stringCase],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.movimentacaoTipos = []
                this.form.movimentacaoSubtipos = []
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.setores = []
                this.form.usuarios = []
                this.form.origensProgramaticas = []
                this.model.movimentacaoTipo = null
                this.model.movimentacaoSubtipoId = null
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.setorId = null
                this.model.usuarioId = null
                this.model.origemProgramaticaId = null
                this.model.material = null
                this.items = []

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'movimentacao-tipos',
                    periodo: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioMovimentacaoGeral.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => this.form.movimentacaoTipos = Object.assign(response.data.movimentacaoTipos))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
        selectedCols(newValue) {
            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
    },
}
</script>